import { GridSortItem } from "@mui/x-data-grid";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import {
  PatientLabResult,
  PatientLabResultControllerApi,
} from "../../../services";
import { Identified } from "../../../types/sdk-types";
import {
  DGT_Pagination,
  asPaginatedContent,
  getConfigObject,
  getPageIndexWhileSearch,
  useBaseContent,
} from "../../../utils/utils";

interface Props {
  pagination: DGT_Pagination;
  gridSorting?: GridSortItem[];
  patientId: string;
  status?: boolean;
  archive?: boolean;
  xTENANTID?: string;
}

/**
 *
 * @author Rajkumar Rathod
 */
export const useGetOrderResults = ({
  pagination,
  gridSorting,
  patientId,
  status,
  archive,
  xTENANTID,
}: Props): useBaseContent<Identified<PatientLabResult>> => {
  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination,
    searchKey: "",
    prevPage,
  });

  const sortData = gridSorting?.[0];
  return useQuery({
    queryKey: [
      "patient-orders-results-list",
      pageIndex,
      pagination.pageSize,
      sortData?.sort ?? undefined, // sortDirection
      patientId,
      status,
      archive,
      xTENANTID,
    ],

    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    queryFn: async () =>
      await new PatientLabResultControllerApi(getConfigObject())
        .getAllLabResults(
          patientId,
          pagination.page,
          pagination.pageSize,
          sortData?.field, // sortDirection
          sortData?.sort ?? undefined, // sortDirection
          status,
          archive,
          xTENANTID
        )
        .then((res) =>
          asPaginatedContent<Identified<PatientLabResult>>(res?.data)
        ),
  });
};
